// Post-submit acknowledgement. Picks up ?id=SK-YYYY-NNNN from the URL and
// surfaces it so the user has a reference to quote.
import './site';
import { loadConfig } from '../envConfig';

void loadConfig();

const requestId = new URL(window.location.href).searchParams.get('id');
if (requestId) {
  const target = document.querySelector<HTMLElement>('[data-request-id]')
    ?? document.querySelector<HTMLElement>('.success-id')
    ?? document.querySelector<HTMLElement>('.wizard__panel-head');
  if (target) {
    const ref = document.createElement('div');
    ref.style.cssText = 'margin-top:16px;font-weight:600;color:var(--sk-blue-600,#0a2a5c);';
    ref.textContent = `Reference: ${requestId}`;
    target.appendChild(ref);
  }
}
